import { Document, View, Image, Page, Text } from '@react-pdf/renderer'
import React from 'react'
import { css } from './css'
import { images } from '../../../../../config/paths';



export const PDFGenerated = ({ userName, data, rows }) => {
    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes;
    let dateRegister = dia + "-" + mes + "-" + f.getFullYear();
    let fechahora = new Date(); let hora = fechahora.getHours(); let minuto = fechahora.getMinutes(); let segundo = fechahora.getSeconds();
    if (minuto < 10) minuto = "0" + minuto; if (segundo < 10) segundo = "0" + segundo;
    let hourRegister = `${hora}:${minuto}:${segundo}`;

    // Trabajando data
    const campos = ["UTILIDAD", "INGRESO_ANTES_IVA", "COSTO_HDL", "COSTO_REFACCIONES"];

    const totales = campos.reduce((acc, campo) => {
        acc[campo] = data.reduce((sum, item) => sum + parseFloat(item[campo] || 0), 0);
        return acc;
    }, {});

    const promedios = campos.reduce((acc, campo) => {
        acc[campo] = data.length > 0 ? totales[campo] / data.length : 0;
        return acc;
    }, {});


    return (
        <Document title='Reporte de Comisiones' producer='HDL Technology' pdfVersion='1.0'>
            <Page size="LETTER" orientation='portrait'>
                {/* Encabezado */}
                <View style={css.row}>
                    <View style={[css.px_4, { marginTop: 20 }]}>
                        <Image src={images.logo} style={css.logo} />
                    </View>
                    <View style={[css.px_3, { marginTop: 20 }]}>
                        <Text style={[css.h1, css.fw_bold]}>HARDWARE DIAGNOSTIC LAB OF TECHNOLOGY</Text>
                        <Text style={[css.h6, css.px_8,]}>Reporte de Ordenes de servicio y Ventas (COMISIONES)</Text>
                    </View>
                    <View style={[css.px_3, { marginTop: 20 }]}>
                        <Text style={[css.tText]}>Dia:    {dateRegister}</Text>
                        <Text style={[css.tText]}>Hora: {hourRegister} hrs.</Text>
                        <Text style={[css.tText]}>Cap.   {userName}</Text>
                    </View>
                </View>

                {/* Sumario */}
                <View style={[css.row, { marginTop: 20 }]}>
                    <View style={[css.px_4, css.text_center]}>
                        <Text style={[css.px_1, css.py_1, css.h6, css.fwBold]}>SUMARIO</Text>
                        <View style={css.line} />
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Ingreso antes IVA:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.INGRESO_ANTES_IVA)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Costo servicio:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.COSTO_HDL)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Costo refacciones:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.COSTO_REFACCIONES)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Utilidad:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.UTILIDAD)}</Text>
                        </View>
                    </View>

                    <View style={[css.px_4, css.text_center]}>
                        <Text style={[css.px_1, css.py_1, css.h6, css.fwBold]}>PROMEDIO</Text>
                        <View style={css.line} />
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Ingreso antes IVA:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.INGRESO_ANTES_IVA)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Costo servicio:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.COSTO_HDL)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Costo refacciones:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.COSTO_REFACCIONES)}</Text>
                        </View>
                        <View style={[css.row, css.space_between]} >
                            <Text style={[css.h6]}>Utilidad:</Text>
                            <Text style={[css.h6, css.px_5]}>{Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.UTILIDAD)}</Text>
                        </View>
                    </View>

                    <View style={[css.px_5,css.py_4, css.text_center, { marginTop: 10 }]}>
                        <View style={[]}>
                            <View style={[css.line, { marginVertical: 4 }]} />
                            <View style={[css.row, css.space_between]}>
                                <Text style={[css.h6, css.fwBold, css.px_5, css.py_5]}> Empleado(s):</Text>
                            </View>
                        </View>
                        <View style={[{ marginTop: 30 }]}>
                            <View style={[css.line, { marginVertical: 4 }]} />
                            <View style={[css.row, css.space_between]}>
                                <Text style={[css.h6, css.fwBold, css.px_5, css.py_5]}>Encargado:</Text>
                            </View>
                        </View>
                    </View>
                </View>

                {/* Detalles */}
                <Text style={[css.px_4, css.py_1, css.h6, css.fwBold, { marginTop: 5 }]}>Trabajo realizado (Ordenes / Ventas): {rows} </Text>
                <View style={[css.row, css.px_4, css.py_4, { marginTop: 5 }]}>
                    <View style={css.table}>
                        <View style={css.tableRowHeader}>
                            <Text style={[css.tableCellHeader]}>FOLIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>INGRESO ANTES IVA</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>COSTO DEL SERVICIO</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>COSTO REFACCIONES</Text>
                            <Text style={[css.tableCellHeader, css.lastCell, css.text_end]}>UTILIDAD</Text>
                        </View>

                        {data.map((item, index) => (
                            <View key={index} style={css.tableRow}>
                                <Text style={css.tableCell}>{item.FOLIO}</Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.INGRESO_ANTES_IVA)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_HDL)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.COSTO_REFACCIONES)}
                                </Text>
                                <Text style={[css.tableCell, css.lastCell, css.text_end]}>
                                    {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(item.UTILIDAD)}
                                </Text>
                            </View>
                        ))}

                        <View style={[css.tableRow, { backgroundColor: '#6c757d' }]}>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Total</Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.INGRESO_ANTES_IVA)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.COSTO_HDL)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.COSTO_REFACCIONES)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(totales.UTILIDAD)}
                            </Text>
                        </View>
                        <View style={[css.tableRow, { backgroundColor: '#17a2b8' }]}>
                            <Text style={[css.tableCell, css.fw_bold, css.text_end]}>Promedio (%)</Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.INGRESO_ANTES_IVA)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.COSTO_HDL)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.COSTO_REFACCIONES)}
                            </Text>
                            <Text style={[css.tableCell, css.lastCell, css.text_end, css.fw_bold]}>
                                {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(promedios.UTILIDAD)}
                            </Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}
